import { MoreVerticalDarkIcon } from "../../../../assets/icons";
import { Avatar } from "../../../data/Avatar";
import { DropdownButton } from "../../../forms/DropdownButton/DropdownButton";
import { DropdownItem } from "../../../forms/DropdownButton/DropdownItem";
import { DiscussionEditState, DiscussionReplyData } from "../../useDiscussionsPanel";
import { DiscussionTextInput } from "../DiscussionTextInput";

const UnreadDot = (): JSX.Element => <span className="DiscussionUnreadDot" aria-label="Unread" />;

export interface DiscussionReplyItemProps {
  reply: DiscussionReplyData;
  threadUuid: string;
  editState: DiscussionEditState | null;
  canEditOrDelete: boolean;
  isResolved?: boolean;
  onStartEditReply: (threadUuid: string, replyUuid: string, content: string) => void;
  onEditDraftChange: (value: string) => void;
  onSaveEdit: () => void;
  onCancelEdit: () => void;
  onDeleteReply: (threadUuid: string, replyUuid: string) => void;
}

export const DiscussionReplyItem = ({
  reply,
  threadUuid,
  editState,
  canEditOrDelete,
  isResolved = false,
  onStartEditReply,
  onEditDraftChange,
  onSaveEdit,
  onCancelEdit,
  onDeleteReply,
}: DiscussionReplyItemProps): JSX.Element => {
  const isEditing =
    editState?.type === "reply" && editState.threadUuid === threadUuid && editState.replyUuid === reply.uuid;

  return (
    <div className="DiscussionReplyItem">
      <div className="DiscussionReplyItem__header">
        <div className="DiscussionReplyItem__meta">
          <Avatar name={reply.authorName} />
          <span className="DiscussionsMeta__author">{reply.authorName}</span>
          <span className="DiscussionsMeta__date">{reply.date}</span>
          {reply.isUnread && <UnreadDot />}
        </div>
        {canEditOrDelete && !isResolved && (
          <DropdownButton component={<MoreVerticalDarkIcon />} ariaLabel="Reply options">
            <DropdownItem onClick={() => onStartEditReply(threadUuid, reply.uuid, reply.content)}>
              Edit message
            </DropdownItem>
            <DropdownItem onClick={() => onDeleteReply(threadUuid, reply.uuid)}>Delete message</DropdownItem>
          </DropdownButton>
        )}
      </div>

      <div className="DiscussionReplyItem__body">
        {isEditing ? (
          <DiscussionTextInput
            value={editState.draft}
            placeholder="Edit your reply"
            onChange={onEditDraftChange}
            onSave={onSaveEdit}
            onCancel={onCancelEdit}
          />
        ) : (
          <p className="DiscussionsMeta__message">{reply.content}</p>
        )}
      </div>
    </div>
  );
};
